<template>
  <div class="cx-div">
    <content-placeholders :animated="false">
      <content-placeholders-img />
    </content-placeholders>

    <content-placeholders 
      :animated="false"
      :rounded="true" 
      style="padding-top: 1rem">
      <content-placeholders-text :lines="1" />
      <div style="padding: 2rem">
       <content-placeholders-img />
      </div>

      <div style="padding: 2rem">
       <content-placeholders-img />
      </div>

      <div style="padding: 2rem">
       <content-placeholders-img />
      </div>

      <div style="padding: 2rem">
       <content-placeholders-img />
      </div>
    </content-placeholders>
  </div>
</template>

<script>
export default {
  name: 'home-loading-placeholder'
}
</script>